var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.48489 8.12865L12.3364 10.9684C12.4468 11.0784 12.4468 11.2561 12.3364 11.3661L11.8055 11.8947C11.6951 12.0047 11.5166 12.0047 11.4062 11.8947L8.55475 9.05497C8.50308 9.00117 8.47254 8.93099 8.47254 8.85614V8.54737C7.61522 9.28421 6.49953 9.73099 5.27814 9.73099C2.57934 9.73099 0.392578 7.55322 0.392578 4.8655C0.392578 2.17778 2.57934 0 5.27814 0C7.97694 0 10.1637 2.17778 10.1637 4.8655C10.1637 6.08187 9.71507 7.19298 8.97519 8.04678H9.28524C9.3604 8.04678 9.43086 8.07485 9.48489 8.12865ZM1.51996 4.8655C1.51996 6.93333 3.20172 8.60819 5.27808 8.60819C7.35444 8.60819 9.03619 6.93333 9.03619 4.8655C9.03619 2.79766 7.35444 1.12281 5.27808 1.12281C3.20172 1.12281 1.51996 2.79766 1.51996 4.8655Z",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchHeader);
export default __webpack_public_path__ + "static/media/search-header.cbba512d.svg";
export { ForwardRef as ReactComponent };